// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"79872fe1","787":"9e90ff23"}[chunkId] + ".chunk.js";
};